import styled, { css } from 'styled-components';

export const PaddingX = css`
  padding-left: var(--left-spacing);
  padding-right: var(--left-spacing);
`;

export const Footer = styled.div`
  border-top: 1px solid var(--gray-20);
  padding: var(--spacing-04) 0;
  margin-left: var(--spacing-06);
  margin-right: var(--spacing-06);
`;
